export default "__VITE_ASSET__ZvjeV7d4__"